import React, { useState, useEffect } from 'react';
import { BACKEND_URL } from '../utils/config';

function ReportModal({ isOpen, onClose, reportId }) {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen && reportId) {
      fetchReport();
    }
  }, [isOpen, reportId]);

  const fetchReport = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${BACKEND_URL}/reports/${reportId}`, {
          method: 'GET',
          credentials: 'include'
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch report: ${response.status}`);
      }
      
      try {
        const data = await response.json();
        setReport(data);
      } catch (jsonError) {
        // Handle cases where the response is not valid JSON
        console.error('Error parsing JSON:', jsonError);
        throw new Error('Received an invalid response from the server.');
      }

    } catch (err) {
      console.error('Error fetching report:', err);
      setError(err.message || 'Failed to load report');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Report Details</h2>
          <button className="modal-close" onClick={onClose} aria-label="Close modal">
            ×
          </button>
        </div>

        {loading && (
          <div className="modal-form" style={{ textAlign: 'center', padding: '40px' }}>
            <div className="loading-spinner" style={{ margin: '0 auto 20px' }}></div>
            <p style={{ color: '#64748b' }}>Loading report...</p>
          </div>
        )}

        {error && (
          <div className="modal-form">
            <div style={{ color: '#ef4444', padding: '20px', textAlign: 'center' }}>
              <p style={{ margin: '0' }}>Error: {error}</p>
            </div>
          </div>
        )}

        {report && !loading && (
          <div className="appointment-details-content">
            <div className="detail-row">
              <span className="detail-label">Report ID:</span>
              <span className="detail-value">{report.report_id}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Patient Name:</span>
              <span className="detail-value caregiver-id">{report.user_username || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Caregiver Name:</span>
              <span className="detail-value caregiver-id">{report.psw_username || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Created:</span>
              <span className="detail-value">
                {new Date(report.created_at).toLocaleDateString(undefined, {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </span>
            </div>
            {report.updated_at && (
              <div className="detail-row">
                <span className="detail-label">Updated:</span>
                <span className="detail-value">
                  {new Date(report.updated_at).toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </span>
              </div>
            )}
            <div className="detail-row">
              <span className="detail-label">Title:</span>
              <span className="detail-value">{report.title || 'N/A'}</span>
            </div>
            {report.description && (
              <div className="detail-row">
                <span className="detail-label">Description:</span>
                <span className="detail-value">{report.description}</span>
              </div>
            )}
          </div>
        )}

        <div className="modal-actions">
          <button
            type="button"
            className="modal-button-cancel"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReportModal;
